import React from 'react';
import PropTypes from 'prop-types';

import { CommonShell } from '../common/CommonShell/CommonShell';
import TransactionStaticCard from '../TransactionStaticCard';
import { TransactionAmount } from '../TransactionAmount';
import TransactionMethodComponent from '../TransactionMethodComponent';
import TransactionAbroad from '../TransactionAbroad';
import { CommonModal } from '../common/CommonModal';

const TransactionAlertComponent = ({
  backClick,
  accountDetails,
  content,
  transactionAmount,
  toggleList,
  handleAmountChange,
  handleOnBlur,
  handleTransactionBalRequestPacket,
  handleTransactionToggleRequestPacket,
  abroadTransactionAlerts,
  amountTransactionAlerts,
  userPhoneNumber,
  showButton,
  cancelAlertChanges,
  showAmountButton,
  isLoading,
  showTransactionMethods,
  toggleTransactionMethod,
  handleTransactionMethodChange,
  transactionError,
  closePopup,
  retryRequest,
  isAmountValid,
  getAbroadURL,
  showAbroadPopup,
  isAbroadPopupEnabled,
  closeAbroadPopup,
}) => {
  return (
    <CommonShell backClick={backClick}>
      <TransactionStaticCard
        accountDetails={accountDetails}
        content={content}
        userPhoneNumber={userPhoneNumber}
      />
      <TransactionAmount
        content={content}
        isTransactionAmountEnable={amountTransactionAlerts.enabled}
        defaultAmount={amountTransactionAlerts.amount.value}
        transactionAmount={transactionAmount}
        handleAmountChange={handleAmountChange}
        handleOnBlur={handleOnBlur}
        handleTransactionBalRequestPacket={handleTransactionBalRequestPacket}
        showButton={showButton}
        cancelAlertChanges={cancelAlertChanges}
        showAmountButton={showAmountButton}
        isLoading={isLoading}
        isAmountValid={isAmountValid}
      />
      <TransactionAbroad
        content={content}
        isAbroadEnabled={abroadTransactionAlerts}
        handleTransactionToggleRequestPacket={handleTransactionToggleRequestPacket}
        getAbroadURL={getAbroadURL}
        showAbroadPopup={showAbroadPopup}
        isAbroadPopupEnabled={isAbroadPopupEnabled}
        closeAbroadPopup={closeAbroadPopup}
      />
      <TransactionMethodComponent
        toggleList={toggleList}
        content={content}
        showTransactionMethods={showTransactionMethods}
        toggleTransactionMethod={toggleTransactionMethod}
        handleTransactionMethodChange={handleTransactionMethodChange}
      />
      {transactionError && (
        <CommonModal
          isOpen={transactionError}
          onRequestClose={closePopup}
          onPrimaryBtnClick={retryRequest}
        />
      )}
    </CommonShell>
  );
};

TransactionAlertComponent.propTypes = {
  backClick: PropTypes.func,
  accountDetails: PropTypes.shape({}),
  content: PropTypes.shape({}),
  transactionAmount: PropTypes.string,
  handleAmountChange: PropTypes.func,
  toggleList: PropTypes.array,
  handleTransactionBalRequestPacket: PropTypes.func,
  handleTransactionToggleRequestPacket: PropTypes.func,
  abroadTransactionAlerts: PropTypes.bool,
  amountTransactionAlerts: PropTypes.shape({}),
  userPhoneNumber: PropTypes.array,
  showButton: PropTypes.func,
  cancelAlertChanges: PropTypes.func,
  showAmountButton: PropTypes.bool,
  isLoading: PropTypes.bool,
  showTransactionMethods: PropTypes.bool,
  toggleTransactionMethod: PropTypes.func,
  handleTransactionMethodChange: PropTypes.func,
  transactionError: PropTypes.bool,
  closePopup: PropTypes.func,
  retryRequest: PropTypes.func,
  handleOnBlur: PropTypes.func,
  isAmountValid: PropTypes.bool,
  getAbroadURL: PropTypes.func,
  showAbroadPopup: PropTypes.func,
  isAbroadPopupEnabled: PropTypes.bool,
  closeAbroadPopup: PropTypes.func,
};
export default TransactionAlertComponent;
